"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/unified-presence`;
    }
    /**
     * Returns the unified presence status of the requested user(s). The set of parameters returned by this method differs whether you return the requester's presence or any other user presence.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/unified-presence
     * Rate Limit Group: Medium
     * App Permission: ReadPresence
     * User Permission: ReadPresenceStatus
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the unified presence for the current user specified in path.
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/unified-presence
     * Rate Limit Group: Medium
     * App Permission: EditPresence
     * User Permission: EditPresenceStatus
     */
    async patch(updateUnifiedPresence, restRequestConfig) {
        const r = await this.rc.patch(this.path(), updateUnifiedPresence, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map